export default __webpack_public_path__ + "static/gradient-653a7c2ef098d992daa628b2a3589a43.mp4";